import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track"]

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.trackTarget.style.animation = "none"
      return
    }
    this.trackTarget.addEventListener("mouseenter", () => {
      this.trackTarget.style.animationPlayState = "paused"
    })
    this.trackTarget.addEventListener("mouseleave", () => {
      this.trackTarget.style.animationPlayState = "running"
    })
  }
}
